import { render, staticRenderFns } from "./currency-dialog.vue?vue&type=template&id=6133348c&scoped=true"
import script from "./currency-dialog.vue?vue&type=script&lang=js"
export * from "./currency-dialog.vue?vue&type=script&lang=js"
import style0 from "./currency-dialog.vue?vue&type=style&index=0&id=6133348c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6133348c",
  null
  
)

export default component.exports